import React from "react";
import PropTypes from "prop-types";
import LocationSelector from "./LocationSelector";
import { useStoreContext } from "../contexts/storeContext";
import { useUserContext } from "../contexts/userContext";

const StoreSelector = ({ onStoreChange, disabled }) => {
  const { stores, selectedStore, setSelectedStore } = useStoreContext();
  const { user } = useUserContext();

  const handleSelect = (store) => {
    setSelectedStore(store);
    if (onStoreChange) {
      onStoreChange(store);
    }
  };

  // Get store name from /user/me response (user.store.name) instead of selectedStore.name
  const storeName = selectedStore?.name || user?.store?.name || "Select Store";

  return (
    <LocationSelector
      location={storeName}
      stores={stores}
      onSelect={handleSelect}
      disabled={disabled}
    />
  );
};

StoreSelector.propTypes = {
  onStoreChange: PropTypes.func,
  disabled: PropTypes.bool,
};

StoreSelector.defaultProps = {
  onStoreChange: null,
  disabled: false,
};

export default StoreSelector;
